/***************************************************************************
 * this is used by various calls to initiate a print of the page
 **************************************************************************/
ht.printPage = function () {
  window.print();
};
